import React, { useState } from "react";
import "../../assets/styles/Pagination.css"

interface PaginationProps {
    page: number;
    total_pages: number;
    total_records: number;
    page_size: number;
    onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
    page,
    total_pages,
    total_records,
    page_size,
    onPageChange
}) => {

    const [gotoPage, setGotoPage] = useState("");

    // Generate page numbers with ellipsis
    const generatePages = () => {
        const pages: (number | string)[] = [];

        if (total_pages <= 7) {
            for (let i = 1; i <= total_pages; i++) pages.push(i);
            return pages;
        }

        pages.push(1);

        if (page > 3) pages.push("...");

        const start = Math.max(2, page - 1);
        const end = Math.min(total_pages - 1, page + 1);

        for (let i = start; i <= end; i++) pages.push(i);

        if (page < total_pages - 2) pages.push("...");

        pages.push(total_pages);

        return pages;
    };

    const handleGoToPage = () => {
        const target = Number(gotoPage);
        if (!target || target < 1 || target > total_pages) return;

        onPageChange(target);
        setGotoPage("");
    };

    return (
        <div style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "15px",
            padding: "15px 0",
            borderTop: "1px solid #e5e7eb",
            flexWrap: "wrap"
        }}>
            {/* Records Info */}
            <div style={{ fontSize: "12px", color: "#4b5563", fontWeight: 500 }}>
                Showing {Math.min(page * page_size, total_records)} of {total_records} records
            </div>

            {/* Pagination Controls */}
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "nowrap",
                whiteSpace: "nowrap"
            }}>
                {/* Prev */}
                <button
                    disabled={page <= 1}
                    onClick={() => onPageChange(page - 1)}
                    style={navBtnStyle(page <= 1)}
                >
                    ←
                </button>

                {/* Page Numbers */}
                {generatePages().map((p, i) =>
                    p === "..." ? (
                        <span key={i} style={{ fontWeight: 600, color: "#6b7280" }}>•••</span>
                    ) : (
                        <button
                            key={i}
                            onClick={() => onPageChange(p as number)}
                            style={pageBtnStyle(p === page)}
                        >
                            {p}
                        </button>
                    )
                )}

                {/* Next */}
                <button
                    disabled={page >= total_pages}
                    onClick={() => onPageChange(page + 1)}
                    style={navBtnStyle(page >= total_pages)}
                >
                    →
                </button>

                {/* Go to Page */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    marginLeft: "12px"
                }}>
                    <span style={{ fontSize: "12px", color: "#4b5563" }}>
                        Go to page
                    </span>

                    <input
                        type="text"
                        value={gotoPage}
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, "");
                            setGotoPage(value);
                        }}
                        onKeyDown={(e) => {
                            if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Enter/.test(e.key)) {
                                e.preventDefault();
                            }
                            if (e.key === "Enter") handleGoToPage();
                        }}
                        onBlur={handleGoToPage}
                        style={{
                            width: "42px",
                            height: "24px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            padding: "0 8px",
                            fontSize: "12px",
                            outline: "none"
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

/* ---------- Styles ---------- */

const navBtnStyle = (disabled: boolean) => ({
    minWidth: "33px",
    // height: "33px",
    // border: "1px solid #d1d5db",
    border: 0,
    borderRadius: "6px",
    backgroundColor: disabled ? "#f9fafb" : "#ffffff",
    color: disabled ? "#9ca3af" : "#374151",
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: "12px",
    fontWeight: 500
});

const pageBtnStyle = (active: boolean) => ({
    minWidth: "33px",
    // height: "33px",
    border: "1px solid #d1d5db8e",
    borderRadius: "6px",
    backgroundColor: active ? "#adadadff" : "#ffffff58",
    color: active ? "#ffffff" : "#374151",
    // fontWeight: active ? 600 : 500,
    fontSize: "12px",
    cursor: "pointer"
});

export default Pagination;
